export default "__VITE_ASSET__8930e35b__"